import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-group-date',
  templateUrl: './form-group-date.component.html',
  styleUrls: ['./form-group-date.component.css']
})
export class FormGroupDateComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Input() messageFooter: string = '';
  @Input() minDate: Date = new Date(1900, 0, 1);
  @Input() maxDate: Date = new Date(2100, 11, 31);
  @Input() minYear: number = -1;
  @Input() maxYear: number = -1;
  @Input() startView: "month" | "year" | "multi-year" = 'month';

  constructor() { }


}
